import {
  jb_x_icon_css_default
} from "./chunk.BAESR3IO.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.RCJUEYAG.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-x-icon/jb-x-icon.ts
var JbXIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        fill="currentColor"
        viewbox="0 0 24 21"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.21556 0H0L8.8455 11.5499L0.994385 20.9073H4.46193L10.5169 13.7323L16.0119 20.9073H23.1L14.27 9.28507L22.1056 0H18.5361L12.5952 7.08074L7.21556 0ZM16.9993 18.9073L4.05078 2H6.22324L19.0687 18.9073H16.9993Z"
        />
      </svg>
    `;
  }
};
JbXIcon.styles = [reset_css_default, jb_x_icon_css_default];
JbXIcon = __decorateClass([
  customElement("jb-x-icon")
], JbXIcon);

export {
  JbXIcon
};
